var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBayer(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 285.63,
    height: 285.582,
    viewBox: "0 0 285.63 285.582",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_48045",
    "data-name": "Group 48045",
    transform: "translate(-196.498 -58.042)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_34619",
    "data-name": "Group 34619",
    transform: "translate(225.594 85.392)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_26830",
    "data-name": "Path 26830",
    d: "M310.881,96.108H327.32a3.3,3.3,0,0,0,0-6.595H310.881Zm0,16h16.924a3.783,3.783,0,0,0,0-7.566H310.881Zm26.477-12.123a11.968,11.968,0,0,1-8.34,20.561h-27.5V81.027h27.06a11.526,11.526,0,0,1,11.492,11.541A11.692,11.692,0,0,1,337.358,99.988Z",
    transform: "translate(-205.648 -81.027)",
    fill: "#002e46"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_26831",
    "data-name": "Path 26831",
    d: "M344.707,160.113H334.62l-3.2-6.595H309.307l-3.2,6.595H296.019l19.737-39.473h9.166Zm-24.3-29.435-6.934,14.354h13.869Z",
    transform: "translate(-206.693 -73.504)",
    fill: "#002e46"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_26832",
    "data-name": "Path 26832",
    d: "M333.85,160.9H345.2l-20.028,25.7v13.821h-9.408V186.606l-20.028-25.7h11.3L320.466,178.9Z",
    transform: "translate(-206.747 -65.856)",
    fill: "#002e46"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_26833",
    "data-name": "Path 26833",
    d: "M377.485,160.9v8.486H351.153v6.547h25.411v8.486H351.153v7.517h26.332v8.486h-35.74V160.9Z",
    transform: "translate(-198.008 -65.856)",
    fill: "#002e46"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_26834",
    "data-name": "Path 26834",
    d: "M398.816,185.345h-7.031v15.034h-9.408V160.9h24a12.227,12.227,0,0,1,3.395,23.957l11.59,15.518h-11.3Zm6.6-15.954H391.736v7.517h13.676a3.746,3.746,0,0,0,3.734-3.783A3.705,3.705,0,0,0,405.412,169.391Z",
    transform: "translate(-190.291 -65.857)",
    fill: "#002e46"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_26835",
    "data-name": "Path 26835",
    d: "M307.173,200.42H297.086l-3.2-6.6H271.772l-3.2,6.6H258.485l19.737-39.475h9.165Zm-24.3-29.436-6.935,14.354h13.87Z",
    transform: "translate(-213.821 -65.849)",
    fill: "#002e46"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_26836",
    "data-name": "Path 26836",
    d: "M230.359,175.986H246.8a3.3,3.3,0,1,0,0-6.6H230.359Zm0,16h16.924a3.783,3.783,0,0,0,0-7.566H230.359Zm26.429-12.124a11.97,11.97,0,0,1-8.341,20.562h-27.5V160.9h27.06a11.529,11.529,0,0,1,8.778,18.961Z",
    transform: "translate(-220.95 -65.857)",
    fill: "#002e46"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_26837",
    "data-name": "Path 26837",
    d: "M337.22,201.21V209.7H310.888v6.547H336.3v8.486H310.888v7.517H337.22v8.486H301.48V201.21Z",
    transform: "translate(-205.656 -58.202)",
    fill: "#002e46"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_26838",
    "data-name": "Path 26838",
    d: "M330.625,254.552a3.777,3.777,0,0,0-3.734-3.783h-16v7.517h16A3.735,3.735,0,0,0,330.625,254.552ZM301.48,281.806V242.331h26.381a12.237,12.237,0,0,1,4.559,23.568L344.3,281.806H333l-11.3-15.033H310.889v15.033Z",
    transform: "translate(-205.656 -50.392)",
    fill: "#002e46"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_34620",
    "data-name": "Group 34620",
    transform: "translate(196.498 58.042)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_26839",
    "data-name": "Path 26839",
    d: "M481.79,191.982a142.8,142.8,0,0,0-285.047,0c.194,3.007.436,5.965.823,8.923a142.794,142.794,0,0,0,141.7,125.017c-66,0-120.217-51.4-124.774-116.24-.194-2.909-.34-5.867-.34-8.826s.1-5.916.34-8.826A125.234,125.234,0,0,1,339.266,75.79a142.748,142.748,0,0,1,141.7,125.163c.339,2.911.63,5.82.823,8.778.194-2.909.292-5.868.292-8.826-.049-3.056-.145-5.965-.292-8.923",
    transform: "translate(-196.452 -58.042)",
    fill: "#acc70b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_26840",
    "data-name": "Path 26840",
    d: "M196.837,206.857a142.8,142.8,0,0,0,285.048,0c-.194-3.007-.437-5.965-.825-8.923a142.791,142.791,0,0,0-141.7-125.017c66,0,120.217,51.4,124.775,116.24.194,2.909.339,5.867.339,8.826s-.1,5.916-.339,8.826C459.531,271.742,405.314,323.1,339.313,323.1a142.746,142.746,0,0,1-141.7-125.163c-.339-2.909-.629-5.819-.823-8.777-.194,2.909-.292,5.867-.292,8.826.049,3.007.145,5.965.339,8.874",
    transform: "translate(-196.498 -55.217)",
    fill: "#00b7eb"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBayer);
export default __webpack_public_path__ + "static/media/bayer.27e36c62e4ead24732eae6b7e132bdd9.svg";
export { ForwardRef as ReactComponent };